import { conceptsData, getConceptById } from '@/data/conceptsData';
import { CONCEPT_TRANSLATIONS } from '@/data/i18n/conceptTranslations';
import { LESSON_CODE } from '@/data/i18n/lessonCode';
import { getLangInfo } from '@/data/languages';

export const getLocalizedConcept = (id, lang) => {
  const base = getConceptById(id);
  if (!base || lang === 'java') return base;
  const t = CONCEPT_TRANSLATIONS[id]?.[lang];
  return t ? { ...base, ...t } : base;
};

export const getLocalizedConcepts = (lang) => conceptsData.map(c => getLocalizedConcept(c.id, lang));

// Returns code for a lesson plus a mapper from engine (Java) line numbers to displayed line numbers
const isNoise = (line = '') => {
  const t = line.trim();
  return !t || t.startsWith('//') || t.startsWith('#') || t.startsWith('/*') || t.startsWith('*') || /^[{}]+;?$/.test(t);
};

// Move a highlight off blank/comment/brace lines onto the nearest following statement
const settle = (lines, n) => {
  if (n == null) return null;
  for (let i = n; i <= Math.min(lines.length, n + 3); i++) if (!isNoise(lines[i - 1])) return i;
  return n;
};

export const getLessonCode = (lesson, lang) => {
  const file = getLangInfo(lang).file;
  const t = lang !== 'java' && LESSON_CODE[lesson.id]?.[lang];
  if (!t) {
    const jl = lesson.javaCode.split('\n');
    return { code: lesson.javaCode, file: getLangInfo('java').file, toLine: (l) => settle(jl, l) };
  }
  const lines = t.code.split('\n');
  const jl = lesson.javaCode.split('\n');
  const firstForJava = {};
  t.map.forEach((j, i) => { if (j != null && firstForJava[j] == null) firstForJava[j] = i + 1; });
  const toLine = (rawLine) => {
    const javaLine = settle(jl, rawLine);
    if (javaLine == null) return null;
    for (let j = javaLine; j >= 1; j--) if (firstForJava[j] != null) return settle(lines, firstForJava[j]);
    return null;
  };
  return { code: t.code, file, toLine };
};
